import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchReports = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/reports/locations`);
    if (!response.ok) throw new Error("Не вдалося завантажити звіти");
    return response.json();
};